import { Box } from "components/Box";
import { Investment } from "components/Investment";
import { Pagination } from "components/Pagination";
import { useInvestments } from "hooks/investments";
import { usePagination } from "hooks/pagination";
import { useWindowWidth } from "hooks/useWindowWidth";
import React, { useEffect, useRef } from "react";
import { Row } from "react-grid-system";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IAddAdvertisementResponse } from "services/advertisements";
import {
  addAdvertisement,
  getAdvertisements,
} from "store/advertisement/actions";
import { IAdvertisementsState } from "store/advertisement/types";
import { IRootState } from "store/rootReducer";
import { eventBus } from "utilities/eventBus";

export const AdvertisementsCurrentView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const investmentsRef = useRef<HTMLDivElement>(null);
  const advertisements: IAdvertisementsState = useSelector(
    (data: IRootState) => data.advertisements
  );
  const { investments } = useInvestments({
    advertisements: advertisements.data,
    view: "horizontal",
    isPrivate: true,
  });

  const windowWidth = useWindowWidth();

  const { handleChangePage } = usePagination({
    paginatedElRef: investmentsRef,
    updateFn: (pageNumber) => {
      dispatch(
        getAdvertisements({
          finished_status: false,
          filter: "my_advertisements",
          page: pageNumber,
        })
      );
    },
  });

  const moveToEdit = (id: number) => {
    history.push(`/advertisements/${id}/edit`);
  };

  useEffect(() => {
    eventBus.on("addNewAdvertisement", (data: IAddAdvertisementResponse) => {
      dispatch(addAdvertisement(data));
    });

    return () => {
      eventBus.remove("addNewAdvertisement", () => null);
    };
  }, []);

  return (
    <>
      <div ref={investmentsRef}>
        {investments.map((investment) => (
          <Box key={investment.id} mb={4}>
            <Investment
              {...investment}
              my
              myAdvertisements
              editInvestment={moveToEdit}
              view={windowWidth < 1000 ? "vertical" : "horizontal"}
            />
          </Box>
        ))}
      </div>
      <Row justify="end">
        <Pagination
          current={advertisements.pagination.current}
          pages={advertisements.pagination.pages}
          onPageClick={handleChangePage}
        />
      </Row>
    </>
  );
};
